import { lazy, type FC, type ReactElement, Suspense } from 'react'

import { Loader } from '../components/Loader'
import { useRequireAuth } from '../hooks/useRequireAuth'

const LazyTrustedDeviceManagementPage = lazy(() =>
  import('../pages/TrustedDeviceManagement/TrustedDeviceManagementPage').then((module) => ({
    default: module.TrustedDeviceManagementPage,
  })),
)

export const TrustedDeviceManagementRoute: FC = (): ReactElement => {
  const { isAuthenticated } = useRequireAuth()

  if (!isAuthenticated) {
    return <Loader />
  }

  return (
    <Suspense fallback={<Loader />}>
      <LazyTrustedDeviceManagementPage />
    </Suspense>
  )
}
